import axios from 'axios';

export const orderProduct = async (formData) => {
  const url = `${Spree.routes.populate_order_url}`;
  const config = { headers: { 'content-type': 'multipart/form-data' } };

  const csrfToken = document.querySelector('meta[name="csrf-token"]').content;
  if (csrfToken) config.headers['X-CSRF-Token'] = csrfToken;

  return axios.post(url, formData, config);
};

export const removeLineItemsFromOrder = async (lineItemIds) => {
  const url = `/cart`;
  const config = { headers: { 'content-type': 'multipart/form-data' } };

  const csrfToken = document.querySelector('meta[name="csrf-token"]').content;
  if (csrfToken) config.headers['X-CSRF-Token'] = csrfToken;

  const formData = new FormData();
  formData.append('utf8', '✓');
  formData.append('_method', 'patch');

  lineItemIds.forEach((id, idx) => {
    formData.append(`order[line_items_attributes][${idx}][id]`, id);
    formData.append(`order[line_items_attributes][${idx}][quantity]`, 0);
  });

  return axios.post(url, formData, config);
};
